
  <h2 mat-dialog-title class="css-1ihths2">Confirmation</h2>
  <mat-dialog-content style="padding: 16px">
    {{ data.message }}
  </mat-dialog-content>
  <mat-dialog-actions align="end">

    <button mat-dialog-close="confirm" class="btn-bleu"> Suivre la commande <span class="css-pt151d"></span></button>
  </mat-dialog-actions>

